var searchBox = '.search-box'; // 絞り込む項目を選択するエリア
var listItem = '.list_item';   // 絞り込み対象のアイテム
var hideClass = 'is-hide';     // 絞り込み対象外の場合に付与されるclass名

$(function () {
  // 初期表示時にURLパラメータがある場合の処理
  var urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('filter_id')) {
    var tags = urlParams.get('filter_id').split(',');
    if (validateTags(tags)) {
      tags.forEach(function (tag) {
        $('#' + tag).prop('checked', true);
      });
      search_filter();
    } else {
      // 無効なパラメータの場合の処理
      window.history.replaceState('', '', window.location.pathname);
    }
  }

  // 絞り込み項目を変更した時
  $(document).on('click', searchBox + ' .item', function () {
    search_filter();
    updateURL();
  });
});

// URLを更新する関数
function updateURL() {
  var selectedTags = [];
  $('[name=tag]:checked').each(function () {
    selectedTags.push($(this).val());
  });

  var newURL;
  if (selectedTags.length > 0) {
    // チェックされた項目があれば、それらをカンマ区切りでパラメータに設定
    newURL = '?filter_id=' + selectedTags.join(',');
  } else {
    // チェックされた項目がなければパラメータなしに
    newURL = window.location.pathname;
  }

  window.history.pushState('', '', newURL);
}

// 有効なタグかどうかをチェックする関数
function validateTags(tags) {
  var validTags = ['hotel', 'dormitory', 'welfare', 'corporate', 'senior'];
  return tags.every(tag => validTags.includes(tag));
}

function search_filter() {
  // 非表示状態を解除
  $(listItem).removeClass(hideClass);
  for (var i = 0; i < $(searchBox).length; i++) {
    var name = $(searchBox).eq(i).find('input').attr('name');
    // 選択されている項目を取得
    var searchData = get_selected_input_items(name);
    // 選択されている項目がない、またはALLを選択している場合は飛ばす
    if (searchData.length === 0 || searchData[0] === '') {
      continue;
    }
    // リスト内の各アイテムをチェック
    for (var j = 0; j < $(listItem).length; j++) {
      // アイテムに設定している項目を取得
      var itemData = get_setting_values_in_item($(listItem).eq(j), name);
      // 絞り込み対象かどうかを調べる
      var check = array_match_check(itemData, searchData);
      if (!check) {
        $(listItem).eq(j).addClass(hideClass);
      }
    }
  }
}

function get_selected_input_items(name) {
  var searchData = [];
  $('[name=' + name + ']:checked').each(function () {
    searchData.push($(this).val());
  });
  return searchData;
}

function get_setting_values_in_item(target, data) {
  var itemData = target.data(data);
  if (!Array.isArray(itemData)) {
    itemData = [itemData];
  }
  return itemData;
}

function array_match_check(arr1, arr2) {
  var arrCheck = false;
  for (var i = 0; i < arr1.length; i++) {
    if (arr2.indexOf(arr1[i]) >= 0) {
      arrCheck = true;
      break;
    }
  }
  return arrCheck;
}
